(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.accordion details');
  accordions.forEach((detail) => {
    detail.addEventListener('toggle', () => {
      if (detail.open) {
        accordions.forEach((other) => {
          if (other !== detail) other.removeAttribute('open');
        });
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
